import { Row } from 'components/Blocks';

import { TaskStatus } from './Status';
import { TaskDate } from './Date';
import { TaskName } from './Name';
import { TaskOwner } from './Owner';
import { TaskTags } from './Tags';

import { TeamTag } from '../../TeamTag';
import { ServiceOutsourcedTag } from 'pages/Projects/components';

import { useTaskModal } from '../context.taskModal';

export function TaskHeader() {
  const { task } = useTaskModal();

  return (
    <div className="grid grid-cols-[80%_1fr] gap-4 small_tablet:grid-cols-[1fr_fit-content(100%)] small_tablet:gap-x-2 phone:pr-5">
      <TaskName />

      <Row gap="2" alignItems="stretch" className="small_tablet:col-span-2 " flexWrap="wrap">
        <TaskStatus />

        <TaskDate />

        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <TeamTag team={(task.team as any)?.id ?? task.team} className="h-full" />

        {task.outsourced && <ServiceOutsourcedTag round={false} />}

        <TaskTags />
      </Row>

      <div className="col-start-2 row-start-1 row-end-3 justify-self-end small_tablet:row-end-2 small_tablet:self-center small_tablet:justify-self-center">
        <TaskOwner />
      </div>
    </div>
  );
}
